import { Release } from "../../../types";
import { FunnelConfigTypes } from "../../../components/funnel/types";
import { useUserData } from "../../../hooks/useUserData";
import { setFunnelModalConfig } from "../../../components/funnel/FunnelModal.tsx";
import { useReleasePurchaseFlow } from "../../../hooks/useReleasePurchaseFlow.ts";

/**
 * Hook that determines if premium content purchase should be available
 * and returns a function to open the purchase funnel, or null if not applicable.
 */
export function useBuyPreviewContext(
  releaseData: Release,
): ((config: FunnelConfigTypes) => void) | null {
  const { userData } = useUserData();

  const { ppb_price_point, release_user_purchase, premium_only, is_free } =
    releaseData ?? {};

  const openPaywall = useReleasePurchaseFlow({
    setFunnelConfig: setFunnelModalConfig,
  });

  // Return null if purchase shouldn't be available
  if (
    release_user_purchase ||
    is_free ||
    !ppb_price_point ||
    (!premium_only && userData?.gold)
  ) {
    return null;
  }

  return openPaywall;
}
